import DepartmentList from "../../slices/hr/department/DepartmentList";
import DepartmentDetails from "../../slices/hr/department/DepartmentDetails";
import GroupTypeList from "../../slices/hr/group_type/GroupTypeList";
import GroupTypeDetails from "../../slices/hr/group_type/GroupTypeDetails";
import GroupList from "../../slices/hr/group/GroupList";
import GroupDetails from "../../slices/hr/group/GroupDetails";
import EmployeeList from "../../slices/hr/employee/EmployeeList";
import EmployeeDetails from "../../slices/hr/employee/EmployeeDetails";
import UserList from "../../slices/hr/user/UserList";

const hrReducer = {
    departmentList: DepartmentList,
    departmentDetails: DepartmentDetails,
    groupTypeList: GroupTypeList,
    groupTypeDetails: GroupTypeDetails,
    groupList: GroupList,
    groupDetails: GroupDetails,
    employeeList: EmployeeList,
    employeeDetails: EmployeeDetails,
    userList: UserList,

};

export default hrReducer;